
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import WxHeader from './Header'
import WxFooter from './Footer'

export default {
components: {
Tab,
TabItem,
Swiper,
SwiperItem,
WxHeader,
WxFooter
},
data () {
return {
tag : '缴费中心',
detail:{
content : '',
reply_content: '',
create_date : '',
update_date : '',
status_text : ''
}
}
},
created(){
this.init();
},
methods: {
init(){
let _self = this;
let id = this.$route.query.id;
let index_url = '/MemberCenter';
if(!id || id<= 0){
window.location.href = index_url;
return false;
}
let formData = {};
let login_data = this.get_login_session_data();
let access_token = this.get_access_token();
if(login_data && access_token){
formData.openid = login_data.openid;
formData.member_id = login_data.member_id;
formData.YZICode_cur = login_data.YZICode_cur;
}else{
window.location.href = index_url;
return false;
}
formData.id = id;
formData = this.qs.stringify(formData);

let api_url = this.server_api_url+'service=get_fix_detail';
this.$axios({
method:'post',
url:api_url,
headers: {'token': access_token},
data:formData,
}).then((response) =>{          //这里使用了ES6的语法
let data_arr = response.data;
_self.check_token_data_status(data_arr);
if(!!data_arr.data.detail_row){
let detail_row = data_arr.data.detail_row
_self.detail = detail_row;
}else{
window.location.href = index_url;
}

}).catch((response) =>{
console.log(response)       
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/FixDetail.vue